/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';
import type {
  NonFungibleTimeCollection,
  NonFungibleTimeCollectionInterface,
} from '../NonFungibleTimeCollection';

const _abi = [
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'AlreadyRedeemed',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'buyer',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'CanNotBuyYourOwnToken',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidRoyalty',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidTimeParams',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'NotForSale',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'OnlyCurrentRoyaltyReceiver',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'OnlyTokenOwner',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'TokenDoesNotExist',
    type: 'error',
  },
  {
    inputs: [],
    name: 'TransferFailed',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
    ],
    name: 'UnallowedCurrency',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'buyer',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'UnauthorizedBuyer',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'approved',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
    ],
    name: 'CurrencyAllowanceToggled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'svgGenerator',
        type: 'address',
      },
    ],
    name: 'SvgGeneratorSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'seller',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'buyer',
        type: 'address',
      },
    ],
    name: 'TokenBought',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'allowedBuyer',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'forSale',
        type: 'bool',
      },
    ],
    name: 'TokenBuyingConditionsChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'TokenRedeemed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'royaltyReceiver',
        type: 'address',
      },
    ],
    name: 'TokenRoyaltyReceiverChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'buy',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'allowedBuyer',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'forSale',
        type: 'bool',
      },
    ],
    name: 'changeBuyingConditions',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'royaltyReceiver',
        type: 'address',
      },
    ],
    name: 'changeRoyaltyReceiver',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'symbol',
        type: 'string',
      },
      {
        internalType: 'bool',
        name: 'useNativeCurrency',
        type: 'bool',
      },
      {
        internalType: 'address',
        name: 'svgGeneratorContract',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'isCurrencyAllowed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'description',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'category',
        type: 'string',
      },
      {
        internalType: 'uint256',
        name: 'availabilityFrom',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'availabilityTo',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'duration',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'royaltyBasisPoints',
        type: 'uint256',
      },
    ],
    name: 'mint',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'redeem',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'salePrice',
        type: 'uint256',
      },
    ],
    name: 'royaltyInfo',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newSvgGenerator',
        type: 'address',
      },
    ],
    name: 'setSvgGenerator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'svgGenerator',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
    ],
    name: 'toggleCurrencyAllowance',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'tokens',
    outputs: [
      {
        internalType: 'uint256',
        name: 'availabilityFrom',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'availabilityTo',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'duration',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'royaltyBasisPoints',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'minter',
        type: 'address',
      },
      {
        internalType: 'address payable',
        name: 'royaltyReceiver',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'currency',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'allowedBuyer',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'redeemed',
        type: 'bool',
      },
      {
        internalType: 'bool',
        name: 'forSale',
        type: 'bool',
      },
      {
        internalType: 'string',
        name: 'name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'description',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'category',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalMinted',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

export class NonFungibleTimeCollection__factory extends ContractFactory {
  constructor(...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NonFungibleTimeCollection> {
    return super.deploy(overrides || {}) as Promise<NonFungibleTimeCollection>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): NonFungibleTimeCollection {
    return super.attach(address) as NonFungibleTimeCollection;
  }
  connect(signer: Signer): NonFungibleTimeCollection__factory {
    return super.connect(signer) as NonFungibleTimeCollection__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NonFungibleTimeCollectionInterface {
    return new utils.Interface(_abi) as NonFungibleTimeCollectionInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): NonFungibleTimeCollection {
    return new Contract(address, _abi, signerOrProvider) as NonFungibleTimeCollection;
  }
}
